const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const createAssetTypeFilter = (field: string, keyword: string): string => {
  const term = keyword.trim();
  if (!field || !term) {
    return '';
  }
  return JSON.stringify({ [field]: { $regex: escapeRegExp(term), $options: 'i' } });
};

export default createAssetTypeFilter;
